import StartFromScratchTemplate from 'designer/tours/start-from-scratch.ejs';
import InterfaceWalkthroughTemplate from 'designer/tours/interface-walkthrough.ejs';
import TourStep from 'designer/tours/tour-step.ejs';
import util from 'util/Util';
import constants from 'Constants';
import listService  from 'ListService';
import commonService from 'CommonService.js';
import restService          from 'RestService';
import notificationService  from 'NotificationService.js';
class TourService {

    constructor() {
        this._htmlTour = $("<div id='tour'>");
        this._tourStep = $("<div>");
        this._videoUrl;
        this._currentStep = 1;
        this._tourStarted = false;
        this._tourTag = sessionStorage.getItem('appTourTag');
        //Added fix for zIndex of these elements because they appear over the overlay and I don't want to change their zIndex because of the possible impact
        this._zIndexFix = [{ class: ".topbar" }, { class: ".ui-resizable-handle" }, { class: "#left-extender" }];

    }

    get Tour() {
        return this._tour;
    }

    setTourSteps(type){

        this._steps = [];
                
        switch(type){
            case 'scratch':               
                
                this._steps = [
                    {
                        title: "Name your App",
                        target: ".attributes-section",
                        enableTarget: true,
                        html: this._htmlTour.find("[data-step='1']").html(),
                        onFocus: () => {
                            $(".app-name").trigger("select");
                        },
                        positionOffset: { top: 0, left: 0}
                    },
                    {
                        title: "App Title",
                        target: ".attributes-section",
                        enableTarget: true,
                        html: this._htmlTour.find("[data-step='2']").html(),
                        onFocus: () => {
                            $(".app-title").trigger("select");
                        },
                        positionOffset: { top: 0, left: 0}
                    },
                    {
                        title: "Drag & Drop Controls",
                        target: "#editor-pane,#desktop-toolbar",
                        enableTarget: true,
                        html: this._htmlTour.find("[data-step='3']").html(),
                        onFocus: null,
                        positionOffset: { top: -100, left: 100}
                    },
                    {
                        title: "Save your Changes",
                        target: ".file-menu",
                        enableTarget: true,
                        html: this._htmlTour.find("[data-step='4']").html(),
                        onFocus: () => {
                            $(this._zIndexFix[0].class).css("z-index", this._zIndexFix[0].prevZIndex);
                            setTimeout(function () {
                                $(".file-menu .dropdown-toggle").trigger("click");
                            }, 50);
                        },
                        positionOffset: { top: 0, left: 120}
                    },
                    {
                        title: "Publish your App",
                        target: ".file-menu",
                        enableTarget: true,
                        html: this._htmlTour.find("[data-step='5']").html(),
                        onFocus: () => {
                            $(this._zIndexFix[0].class).css("z-index", this._zIndexFix[0].prevZIndex);
                            setTimeout(function () {
                                $(".file-menu .dropdown-toggle").trigger("click");
                            }, 50);
                        },
                        positionOffset: { top: 120, left: 120}
                    }
                ];

            break;
            case 'report':
            break;
            default:
                this._steps = [
                    {
                        title: "Navigation Panel",
                        target: ".left-rail",
                        enableTarget: false,
                        html: this._htmlTour.find("[data-step='1']").html(),
                        onFocus: null,
                        positionOffset: { top: 0, left: -75}
                    },
                    {
                        title: "Toolbox",
                        target: "#desktop-toolbar",
                        enableTarget: false,
                        html: this._htmlTour.find("[data-step='2']").html(),
                        onFocus: null,
                        positionOffset: { top: 0, left: 100}
                    },
                    {
                        title: "Properties Panel",
                        target: ".right-rail",
                        enableTarget: false,
                        html: this._htmlTour.find("[data-step='3']").html(),
                        onFocus: null,
                        positionOffset: { top: 0, left: -30}
                    },
                    {
                        title: "Designer View",
                        target: ".designer-views",
                        enableTarget: false,
                        html: this._htmlTour.find("[data-step='4']").html(),
                        onFocus: null,
                        positionOffset: { top: 0, left: -50}
                    }
                ];

            break;
        }        
    }

    startTour(){
        const overlay = $(this._tourStep.find(".tour-overlay"));
        $("body").append(overlay); 
        this.fixElementsZIndex(false);
        this.showTourStep();
    }

    showTourStep(){

        const currentStepObj = this._steps[this._currentStep - 1];

        $(".exclude").removeClass("exclude");
        $(".tour-step").hide();       

        $(".step-title .text").html(currentStepObj.title);
        $(".step-content").html(currentStepObj.html);
        $(".step-footer").html("Step " + this._currentStep + " of " + this._steps.length);


        const setNav = () =>{

            $(".tour-button").show();

            if(this._currentStep === 1){//First step
                $(".step-navigation .back").hide();
            } 
            else{
                if(this._currentStep === this._steps.length){ //Last step
                    $(".step-navigation .next").html("Finish");
                }
                else{
                    $(".step-navigation .next").html("Next &gt;&gt;");
                }
            }            
        }

        const bindTourEvents = () =>{
            $(".tour-close-button").off().on("click", () =>{
                this.closeTour(false);
            });    

            $(".step-navigation .back").off().on("click", () =>{
                this._currentStep --;
                this.showTourStep();
            });
    
            $(".step-navigation .next").off().on("click", () =>{
    
                if(this._currentStep !== this._steps.length ){ //Last step
                    this._currentStep ++;
                    this.showTourStep();
                }
                else{
                    this.finishTour();
                }
            });
        }

        const setTarget = () =>{
            const targets = currentStepObj.target.split(",");

            _.each(targets, (target) =>{

                if(currentStepObj.enableTarget){
                    $(target).addClass("exclude");
                }
            });

            this.calcStepPosition($(targets[0]), currentStepObj); 

            $(window).off().on("resize", () => {
                this.calcStepPosition($(targets[0]), currentStepObj);
            });
        }

        
        setNav();
        bindTourEvents();
        setTarget();
        
        $(".tour-step").show();

        if(currentStepObj.onFocus){
            currentStepObj.onFocus();
        }
    }


    calcStepPosition (target, currentStep){

        const offset = target.offset();
        const windowMiddleLeft = window.innerWidth / 2;
       
        $(".step-arrow").hide();

        const alignmentOffset = 40;
        let top = offset.top - alignmentOffset + currentStep.positionOffset.top;
        
        const arrowOffset = 90;
        const stepWidth = 350;
        const stepOffset = stepWidth + arrowOffset + currentStep.positionOffset.left;

        let left = offset.left - stepOffset; //Show to the left of the target by default

        if(left <= 0 || (left < stepOffset && (windowMiddleLeft - left <= 0))){ //If not enough space on the left
            left = offset.left + stepOffset; //Show to the right of the target
            $(".step-arrow.arrow-right").fadeOut();
            $(".step-arrow.arrow-left").fadeIn();
        }else{
            $(".step-arrow.arrow-right").fadeIn();
            $(".step-arrow.arrow-left").fadeOut();
        }

        if(top < 0){ //Make sure it does not display outside screen
            top = 1;
        }

         $(".tour-step").animate({ top: top, left: left});
        
    }

    fixElementsZIndex(restore){
                
        _.each(this._zIndexFix,(el) => {

            if (restore) {
                $(el.class).css("z-index", el.prevZIndex);
            }
            else {
                el.prevZIndex = $(el.class).css("z-index")
                $(el.class).css("z-index", "0");
            }
        });
    }

    finishTour(){
        this._tourStarted = false;
        this.fixElementsZIndex(true);
        this._onComplete();
    }

    buildDialog(id){
        const dialog = $(id).dialog({
            autoOpen: false,
            height: "auto",
            dialogClass: "tour-intro-modal",
            closeOnEscape: false,
            minHeight: 150,
            width: 500,
            title: '',
            modal: true,
            resizable: false,
            position: { my: 'top+100', 
                        at: 'center top', 
                        of: 'body'},
            classes: {
                "ui-dialog": "tour-modal-dialog",
                "ui-dialog-titlebar": "dashboard-modal-dialog-titlebar-hidden",
                "ui-dialog-title": "tour-modal-title",
                "ui-dialog-content": "tour-modal-content",
                "ui-widget-overlay": "tour-overlay"
            }
        });

        return dialog;
    }

    bindEvents(){
        $(".close-tour").off().on("click", () =>{
            this._intro.dialog("close");
            this._intro.dialog("destroy");
            this.closeTour(false);
        });

        $(".start-tour").off().on("click", (ev) => {
            this._intro.dialog("close");
            this._intro.dialog("destroy");
            this._currentStep = 1;
           
            if(this._tourStarted){
                this.startTour();
            }else{
                const tour = $(ev.currentTarget).data().tourtype;
                this.initTour(tour);
            }
        });

        $(".help-guide").on("click", (ev)=>{
            ev.preventDefault;
            window.open(constants.HELP_URL, "_blank");
            return false;
        });

        $(".schedule-demo").on("click", (ev)=>{
            ev.preventDefault;
            alert("Open calendly?");
            return false;
        });
    }

    startIntro(type){

        this.setTourSteps(type);
        this._tourStarted = true;
        const intro = $(this._htmlTour.find(".intro"));

        if(intro && intro.length){
            $("#content").append(intro)
            
            const video = $('#video-player')[0];
            video.src = this._videoUrl;
            video.load();

            this.bindEvents();

            this._intro = this.buildDialog("#tour-intro");
            this._intro.dialog("open");
        }
        else{
            this.startTour();
        }
    }

    startOutro(){
        const outro = $(this._htmlTour.find(".outro"));

        if(outro && outro.length){
            $("#content").append(outro)
            
            this.bindEvents();

            if(!this._tourTag){
                this._tourTag = sessionStorage.getItem('appTourTag');
            }

            this._intro = this.buildDialog("#tour-outro" + this._tourTag);

            if(outro.find(".share-app").length > 0){

                const url = $(".share-app-link");
                const _hostUrl = commonService.getHostUrl();
                const appLinkId = listService.currentForm.model.get("appLinkId");
                const formId = listService.currentForm.model.id;
                const appName = listService.currentForm.model.get("name");
                const appLink = (window.localStorage.getItem('checkSingleSignOn') && window.localStorage.getItem('checkSingleSignOn').toString().toLowerCase() === 'true' ? window.localStorage.getItem('DirectoryServiceGatewayURL') : _hostUrl) + '/player.htm?f=' + appLinkId;

                url.val(appLink);

                //Check if published
                const mpvModel = listService.dashboardLayout.mainPanelView.model;
                const publishedVersion = mpvModel.get('deployedVersion') || mpvModel.get('publishedVersion');

                if(!publishedVersion){
                    $("#tour-outro" + this._tourTag + " .regular").hide();
                    $("#tour-outro" + this._tourTag + " .not-published").show();
                }

                $(".share-app-button").on("click", (ev)=>{
                    const current = $(ev.currentTarget);
                    const mode = current.data().mode;

                    const defaultMessage = "The app " + appName + " has been shared with you.\r\n \r\nClick on the following link to view it: \r\n" + appLink;
                    $("#additional-text").val(defaultMessage);

                    $(".charCounter").html($("#additional-text").val().length + " of " + constants.TOUR_EMAIL_MAXCHARS + " used");
                    
                    switch(mode){
                        case 'open':
                            window.open(url.val(), "_blank");
                        break;
                        case 'copy':
                            util.copyValue(url[0].id);
                        break;
                        case 'share':
                            $(".share").show();
                            $(".regular").hide();

                            $("#additional-text").off().on("input", (ev) => {

                                const chars = ev.currentTarget.value.length;

                                if(chars <= constants.TOUR_EMAIL_MAXCHARS){
                                    $(".charCounter").css("color","#2d2d2d");
                                }
                                else{
                                    const truncatedText = ev.currentTarget.value.substring(0, constants.TOUR_EMAIL_MAXCHARS);
                                    $("#additional-text").val(truncatedText);
                                    $(".charCounter").css("color","#bf1212");                                 
                                }

                                $(".charCounter").html(chars + " of " + constants.TOUR_EMAIL_MAXCHARS + " used");
                                    
                            });

                            $(".send-app").off().on("click", () => {

                                const emails = $("#email-addresses").val();

                                if (emails.length === 0) {
                                    $(".email-validation").html("You must introduce at least one valid email.").addClass("email-error").show();
                                }
                                else {
                                    const invalid = util.validateMultipleEmails(emails, ',', 3);

                                    if (Array.isArray(invalid)) {
                                        if (invalid.length > 0) {
                                            $(".email-validation").html("The following emails are invalid: " + invalid.join(",")).addClass("email-error").show();
                                        }
                                        else {
                                            let message = $("#additional-text").val();

                                            if (message !== "") {

                                                const urls = util.detectURLs(message);

                                                if (urls && urls.length) {
                                                    _.each(urls, (url) => {
                                                        if (url !== appLink) {
                                                            message = message.replace(url, "#External links are not allowed for trial accounts.#");
                                                        }
                                                    })
                                                }

                                                const params = {
                                                    formId: formId,
                                                    emails: emails,
                                                    message: message
                                                }

                                                restService.shareAppLinkByEmail(params).then((result) => {
                                                    console.log(result);

                                                    if(result === "OK"){
                                                        $("#email-addresses").val("");
                                                        $("#additional-text").val("");
                                                        $(".buttons").hide();
                                                        $(".tour-button").show();
        
                                                        $(".email-validation").html("Your email has been sent successfully.").removeClass("email-error").show();
                                                    }
                                                    else{
                                                        notificationService.error(result);
                                                    }                                                    
                                                }).catch((err)=> {
                                                    console.log('Error sending email', err);
                                                    notificationService.error('There was an error connecting to the service.');
                                                });;

                                               
                                            }
                                            else{
                                                $(".email-validation").html("You must add a message.").addClass("email-error").show();
                                            }

                                        }
                                    }
                                    else {
                                        $(".email-validation").html(invalid).addClass("email-error").show();
                                    }
                                }

                            });

                            $(".back-outro").off().on("click", () =>{
                                $(".email-validation-error").html("").hide();
                                $("#email-addresses").val("");
                                $("#additional-text").val("");
                                $(".email-validation").hide();

                                $(".share").hide();
                                $(".regular").show();
                            });
                        break;
                        default:
                            window.open(url.val(), "_blank");
                        break;
                    }
        
                });

            }

            this._intro.dialog("open");
            
        }
    }    

    async initTour(type){

        this._tourTag = sessionStorage.getItem('appTourTag');
        this._tourStep.html(TourStep);
        const step = $(this._tourStep.find(".tour-step"));
        $("body").append(step);   

        switch(type){
            case 'walkthrough':
                this._htmlTour.html(InterfaceWalkthroughTemplate); 
                try {
                    this._videoUrl = await util.getURLFromPHPAsync(constants.HELP_VIDEOS + '?id=' + constants.HELP_CENTER_FORMS_VID);
                } catch (error) {
                    console.error("Failed to fetch tour video URL:", error);
                }
            break;
            case 'scratch':
                this._htmlTour.html(StartFromScratchTemplate);   
            break;
            case 'report':
            break;
            default:
                console.log("No tour selected");         
            break;
        }

        this._onComplete = () => {
            this.closeTour(true);
            this.startOutro();
        } 
        
        this.startIntro(type);
    }

    closeTour(complete){
        this.fixElementsZIndex(true);
        $(".tour-overlay").remove();
        $(".exclude").removeClass("exclude");
        $(".tour-step").remove();
        $(".outro").remove();
        $(".intro").remove();
        this._currentStep = 1;

        //TODO check if the tour is already complete
        listService.userSettings.set(this._tourTag, JSON.stringify({show: false, complete: complete}));
    }

}

const tourService = new TourService();
export default tourService;